(function() {
    'use strict';
    angular
        .module('mVtasWebApp')
        .factory('Zetasrealtime', Zetasrealtime);

    Zetasrealtime.$inject = ['$resource', 'DateUtils'];

    function Zetasrealtime ($resource, DateUtils) {
        var resourceUrl =  'api/zetasrealtimes/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.fechadesde = DateUtils.convertDateTimeFromServer(data.fechadesde);
                        data.fechahasta = DateUtils.convertDateTimeFromServer(data.fechahasta);
                        data.fechaoperativa = DateUtils.convertDateTimeFromServer(data.fechaoperativa);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
